import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog(props) {

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.handler}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Your configuration has been saved!</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Save this code to load it in the future: {props.code} <br/>
                        (Or bookmark this URL)
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handler} color="primary" autoFocus>
                        OK
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    );
}